module.exports = __webpack_public_path__ + "img/recs_4.e50a79c1.png";